export default [
  {
    path: '/admin/params',
    name: 'Params',
    component: () => import('@/views/Params/Index.vue'),
    meta: {
      pageTitle: 'Parametreler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'PARAMS_LIST',
      action: 'read',
    },
  },
  {
    path: '/admin/params/add',
    name: 'ParamsAdd',
    component: () => import('@/views/Params/Add.vue'),
    meta: {
      pageTitle: 'Parametreler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/params',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'PARAMS_ADD',
      action: 'read',
    },
  },
  {
    path: '/admin/params/edit/:id',
    name: 'ParamsEdit',
    component: () => import('@/views/Params/Edit.vue'),
    meta: {
      pageTitle: 'Parametreler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/params',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'PARAMS_EDIT',
      action: 'read',
    },
  },
]
